function FormButtons({ registering, onSubmit, onCancel, submitLabel }) {
  return (
    <>
      <button type="button" className="sign" onClick={onSubmit}>
        {submitLabel}
      </button>
      <button type="button" className="cancel" onClick={onCancel}>
        Cancel
      </button>
    </>
  );
}

export default FormButtons;
